import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ServiceProviderService } from "../services/service-provider.service";
import { MapsService } from "src/app/services/maps.service";
import { ApiService } from "src/app/services/api.service";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";

@Component({
  selector: "fury-technician-coverage-modal",
  templateUrl: "./technician-coverage-modal.component.html",
  styleUrls: ["./technician-coverage-modal.component.scss"],
})
export class TechnicianCoverageModalComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  ngUnsubscribe = new Subject<void>();
  technicianCoverageForm = new FormGroup({
    streetAddress: new FormControl("", [Validators.required]),
    city: new FormControl("", [Validators.required]),
    state: new FormControl("", [Validators.required]),
    zip: new FormControl("", [Validators.required]),
    unitNumber: new FormControl(""),
    zipCodes: new FormArray([]),
    states: new FormControl([], [Validators.required]),
  });
  states = [];
  @ViewChild("address", { static: false }) public address!: ElementRef;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<TechnicianCoverageModalComponent>,
    private serviceProviderservice: ServiceProviderService,
    private mapsService: MapsService,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.getAllState();
    this.getServiceProviderData();
  }
  getAllState() {
    this.serviceProviderservice.getStets$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        this.states = res;
      });
  }
  getServiceProviderData() {
    this.apiService
      .get(
        endpoints.partners.serviceProvider.getServiceProviderPartnerCoverageArea(
          this.data?.certifiedServiceProviderId
        )
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            const coverageData = res.body?.claim;
            this.technicianCoverageForm
              .get("streetAddress")
              .setValue(coverageData?.coverageAddress?.streetAddress);
            this.technicianCoverageForm
              .get("city")
              .setValue(coverageData?.coverageAddress?.city);
            this.technicianCoverageForm
              .get("state")
              .setValue(coverageData?.coverageAddress?.state);
            this.technicianCoverageForm
              .get("zip")
              .setValue(coverageData?.coverageAddress?.zip);
            this.technicianCoverageForm
              .get("unitNumber")
              .setValue(coverageData?.coverageAddress?.unitNumber || "");
            this.technicianCoverageForm
              .get("states")
              .setValue(
                coverageData?.states?.map((item: any) => item?.stateId)
              );
            if (coverageData?.zipCode?.length) {
              coverageData?.zipCode?.forEach((item: any) => {
                this.zipCodes.push(
                  new FormControl(item, [Validators.required])
                );
              });
            } else {
              this.zipCodes.push(new FormControl("", [Validators.required]));
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  get zipCodes() {
    return this.technicianCoverageForm.get("zipCodes") as FormArray;
  }
  addField() {
    const newField = new FormControl("", [Validators.required]);
    this.zipCodes.push(newField);
  }

  removeField(index: number) {
    this.zipCodes.removeAt(index);
  }

  updateTechnicianCoverage() {
    if (this.technicianCoverageForm.valid) {
      const payload = {
        address: {
          streetAddress: this.technicianCoverageForm.value.streetAddress,
          city: this.technicianCoverageForm.value.city,
          state: this.technicianCoverageForm.value.state,
          zip: this.technicianCoverageForm.value.zip,
          unitNumber: this.technicianCoverageForm.value.unitNumber
        },
        zipCodes: this.technicianCoverageForm.value.zipCodes,
        states: this.technicianCoverageForm.value.states,
      };
      this.apiService
        .post(
          endpoints.partners.serviceProvider.postServiceProviderPartnerCoverageArea(
            this.data?.certifiedServiceProviderId
          ),
          payload
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res: HttpResponse<any>) => {
            if (res.body) {
              this.apiService.alert(res.body?.message, ErrorType.Success);
              this.dialogRef.close(res);
              this.mapsService.setAddressEvent(null);
            }
          },
          error: (err: HttpErrorResponse) => {
            this.apiService.alert(err.message, ErrorType.Error);
          },
        });
    } else {
      this.technicianCoverageForm.markAllAsTouched();
    }
  }

  chackZipCode() {
    this.apiService
      .getCityState(this.technicianCoverageForm.controls["zip"])
      .then((data) => {
        if (data) {
          this.technicianCoverageForm.patchValue(data);
        } else {
          this.technicianCoverageForm.controls["zip"].setErrors({
            notValid: true,
          });
        }
      });
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.address)
        this.mapsService.autoFillLocation(this.address, "address");
    }, 200);

    this.mapsService.getaddressEvent
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: any) => {
        if (res && typeof res === "object" && res.root === "address") {
          this.technicianCoverageForm
            .get("streetAddress")
            .setValue(res?.address);
          this.technicianCoverageForm.get("city").setValue(res?.city);
          this.technicianCoverageForm.get("state").setValue(res?.state);
          this.technicianCoverageForm.get("zip").setValue(res?.zipcode);
        }
      });
  }
  close() {
    this.mapsService.setAddressEvent(null);
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
